import { useAppSelector } from 'hooks';
import React from 'react';
import { ListItem } from './components';
import { DataStatus } from 'types/enums';
import { CircularProgress } from '@mui/material';

export const ConnectedPatients = () => {
  const { data: caregiverPatients, status } = useAppSelector((state) => state.patients);

  return (
    <div>
      <h4>Related patients:</h4>
      {status === DataStatus.LOADING ? (
        <CircularProgress />
      ) : (
        <ul>
          {caregiverPatients.length
            ? caregiverPatients.map((patient) => (
                <li key={patient.id}>
                  <ListItem {...patient} />
                </li>
              ))
            : 'No connected patients found'}
        </ul>
      )}
    </div>
  );
};
